export const firebaseConfig = {
    apiKey: "AIzaSyD98DKwmm1bXjbqZFhrL4SE-YbmdC1J02w",
    authDomain: "ec-app-3e309.firebaseapp.com",
    databaseURL: "https://ec-app-3e309.firebaseio.com",
    projectId: "ec-app-3e309",
    storageBucket: "ec-app-3e309.appspot.com",
    messagingSenderId: "197049456254",
    appId: "1:197049456254:web:7440e76b6fa46f0c49ea2f"
  };